import { useTranslation } from "react-i18next";
import { StatusDiv } from "./Styles";
import StatusIcon from "components/StatusIcon";

interface AccountStatusProps {
  synced: boolean;
  missingRefreshToken?: boolean;
}

export default function AccountStatus({
  synced,
  missingRefreshToken,
}: AccountStatusProps) {
  const { t } = useTranslation("storage");

  if (!synced)
    return (
      <StatusDiv data-testid="storage__not-synced-label">
        <StatusIcon state="disable" />
        {t("notSynced")}
      </StatusDiv>
    );

  if (missingRefreshToken)
    return (
      <StatusDiv data-testid="storage__revalidation-required-label">
        <StatusIcon state="warning" />
        {t("missingRefreshToken")}
      </StatusDiv>
    );

  return (
    <StatusDiv data-testid="storage__synced-label">
      <StatusIcon state="enable" />
      {t("synced")}
    </StatusDiv>
  );
}
